import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withRouter } from 'react-router-dom'
import IconButton from '@material-ui/core/IconButton'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { ratingsActions, confirmActions, messageActions } from '../../actions'
import { format } from '../../utils'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import EditorFormatListBulleted from 'material-ui/svg-icons/editor/format-list-bulleted'
import queryString from 'querystring'
import { reloadTable } from '../../utils/reloadTable'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentDidMount() {
    const { fetchRatings, term } = this.props

    const { perPage, page, column, direction } = this.getSearchValues()
    const order = { column, direction }

    fetchRatings({ page, perPage, order, term })
  }

  componentWillUpdate(newProps) {
    const { fetchRatings, term, filter } = newProps
    const { perPage, page, column, direction } = this.getSearchValues()

    const order = { column, direction }

    clearTimeout(this.debounce)

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchRatings({ page, perPage, order, term, filter })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  getSearchValues = () => {
    const searchValues = queryString.parse(this.props.location.search) || {}
    const perPage = searchValues.perPage || 50
    const direction = searchValues.direction || -1
    const column = searchValues.column || 'dataUltimaAvaliacao'
    const page = searchValues.page || 0

    return {
      perPage: Number(perPage),
      page: Number(page),
      direction: Number(direction),
      column
    }
  }

  renderActions = item => {
    const { term } = this.props

    return (
      <IconButton
        component={Link}
        to={{
          pathname: `/avaliacoes/${item._id}`,
          state: {
            back: {
              pathname: '/avaliacoes',
              search: this.props.location.search,
              state: {
                term
              }
            }
          }
        }}
      >
        <EditorFormatListBulleted nativeColor={'rgba(0, 0, 0, 0.87)'} />
      </IconButton>
    )
  }

  handleChangePage = (event, page) => {
    this.navigateSearch('page', page)
  }

  navigateSearch = (key, value) => {
    const searchValues = this.getSearchValues()
    const search = queryString.stringify({ ...searchValues, [key]: value })
    this.props.history.push({ search })
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    this.navigateSearch('perPage', perPage)
  }

  changeOrderColumn = column => {
    this.navigateSearch('column', column)
  }
  changeOrderDirection = direction => {
    this.navigateSearch('direction', direction)
  }

  handleSortTable = column => {
    const { order } = this.props
    const { changeOrderColumn, changeOrderDirection } = this

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const { classes, ratings = [], loadingRatings, pagination } = this.props
    const { column, direction } = this.getSearchValues()
    const order = { column, direction }

    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingRatings && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'titulo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('titulo')
                  }}
                >
                  Conteúdo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'tipo'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('tipo')
                  }}
                >
                  Tipo
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'quantidadeAvaliacoes'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('quantidadeAvaliacoes')
                  }}
                >
                  Nr avaliações
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'pendencias'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('pendencias')
                  }}
                >
                  Pendentes
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'notaMedia'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('notaMedia')
                  }}
                >
                  Nota média
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'dataUltimaAvaliacao'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('dataUltimaAvaliacao')
                  }}
                >
                  Ultima avaliação
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '60px', textAlign: 'center' }}>
                Ações
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(ratings || []).length ? (
              (ratings || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>{content.titulo || '--'}</TableRowColumn>
                    <TableRowColumn className={classes.capitalizeField}>
                      {content.tipo || '--'}
                    </TableRowColumn>
                    <TableRowColumn>{content.quantidadeAvaliacoes || '--'}</TableRowColumn>
                    <TableRowColumn>{content.pendencias}</TableRowColumn>
                    <TableRowColumn>{format.round(content.notaMedia) || '--'}</TableRowColumn>
                    <TableRowColumn>
                      {format.date(content.dataUltimaAvaliacao) || '--'}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '60px', textAlign: 'center' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingRatings ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            rowsPerPageOptions={[25, 50, 100]}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    ratings: state.ratings.ratings,
    loadingRatings: state.ratings.loadingRatings,
    token: state.auth.token,
    pagination: state.ratings.ratingsPagination,
    term: state.searchTable.term,
    order: state.ratings.order,
    filter: (state.searchTable.filter || {}).value
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(ratingsActions.openModal())
    },
    closeModal: () => {
      dispatch(ratingsActions.closeModal())
    },
    fetchRating: id => {
      dispatch(ratingsActions.fetchRating(id))
    },
    fetchRatings: options => {
      dispatch(ratingsActions.fetchRatings(options))
    },
    deleteRating: id => {
      dispatch(ratingsActions.deleteRating(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreRating: id => {
      dispatch(ratingsActions.restoreRating(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withStyles(listTableStyle)(ListTable)))



// WEBPACK FOOTER //
// ./src/containers/Ratings/ListTable.js